import { render, staticRenderFns } from "./coring.vue?vue&type=template&id=ba66d362&scoped=true"
import script from "./coring.vue?vue&type=script&lang=js"
export * from "./coring.vue?vue&type=script&lang=js"
import style0 from "./coring.vue?vue&type=style&index=0&id=ba66d362&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba66d362",
  null
  
)

export default component.exports